export default __webpack_public_path__ + "static/media/business-2.8cc0ea15.webp";